import React, { Component } from 'react';
import { Button } from 'reactstrap';

const DownloadButton = props => {
    const downloadFile = () => {
        window.location.href = "https://yoursite.com/src/assets/files/exampleDoc.pdf"
    }
    return (
        <Button onClick={downloadFile} />
    )
}
export default DownloadButton;
